import { TextArea } from "@blueprintjs/core";
import { DailyInstantECharts } from "../charts/daily-instant";
import { useEffect, useState, useRef } from "react";
import { Icon } from "@blueprintjs/core";
import { PageHider } from "../components/PageHider";
import { WeeklyPage } from "../components/WeeklyPage";
import { ImageContainer } from "../components/ImageContainer";
import { WeeklyHeader } from "../components/WeeklyHeader";

export const Page20 = ({
  onPageDataUpdated,
  weekData,
  pageIndex,
  subIndex,
  registerPageIndex,
}: any) => {
  useEffect(() => {
    registerPageIndex(pageIndex, subIndex, "Aktif Kampanyalarımız");
  }, []);

  const [image, setImage] = useState<string | null>(
    weekData?.page20?.image || null
  );
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result as string;
        setImage(base64String);
        onPageDataUpdated("page20", "image", base64String);
      };
      reader.readAsDataURL(file);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current?.click();
  };

  return (
    <WeeklyPage pageId={`page-${pageIndex}-${subIndex}`}>
      <WeeklyHeader title="AKTİF KAMPANYALARIMIZ" />

      <div
        style={{
          width: "100%",
          height: "80%",
          paddingInline: "10px",
          fontFamily: "Open Sans",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          position: "relative",
        }}
      >
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleImageUpload}
        />
        {!image && (
          <button
            onClick={triggerFileInput}
            style={{
              fontSize: "16px",
              cursor: "pointer",
              backgroundColor: "#F7AF3D",
              border: "none",
              borderRadius: "5px",
              color: "white",
              fontWeight: "bold",
            }}
            className="no-print"
          >
            Görsel Yükle
          </button>
        )}
        {image && (
          <div
            style={{
              width: "100%",
              height: "calc(100%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
            }}
          >
            <img
              src={image}
              alt="Uploaded"
              style={{
                height: "100%",
                width: "auto",
                maxWidth: "100%",
                objectFit: "contain",
              }}
              onClick={triggerFileInput}
              className="clickable-image"
            />
            <button
              onClick={() => {
                setImage(null);
                onPageDataUpdated("page20", "image", null);
              }}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                backgroundColor: "red",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "30px",
                height: "30px",
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontWeight: "bold",
              }}
              className="no-print"
            >
              X
            </button>
          </div>
        )}
      </div>
    </WeeklyPage>
  );
};
